import restful from '../vuex'

const state = {
  ...restful.states('unit')
}

const getters = {
  ...restful.getters('unit')
}

const actions = {
  ...restful.actions('units')
}

const mutations = {
  ...restful.mutations('unit')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
